import { Button } from 'app/components/ui/Button'
import { Modal } from 'app/components/ui/Modal'
import { InputHolderDocumentInnerForm } from 'app/pages/DocumentsRegistration/InputHolderDocumentForm/InputHolderDocumentInnerForm'
import { UpdateUserEmailModal } from 'app/pages/Profile/UpdateUserEmailModal'
import { protectedRoutes } from 'app/routing/routes'
import React, { useState } from 'react'
import styled from 'styled-components'

type Props = {
  showChangeEmailButton?: boolean
  className?: string
}

export const UpdateUserActions = ({
  showChangeEmailButton,
  className,
  children,
}: WithChildren<Props>): JSX.Element => {
  const [showUploadDocumentHolderModal, setShowUploadDocumentHolderModal] =
    useState(false)

  const [showUpdateUserEmailModal, setShowUpdateUserEmailModal] =
    useState(false)

  return (
    <>
      <Wrapper className={className}>
        <BodyWrapper>{children}</BodyWrapper>

        <ButtonsWrapper>
          {showChangeEmailButton && (
            <div>
              <Button onClick={() => setShowUpdateUserEmailModal(true)}>
                Aggiorna la tua email
              </Button>
            </div>
          )}
          <div>
            <Button to={protectedRoutes.userRegistration.path}>
              Aggiorna i tuoi dati
            </Button>
          </div>
          <div>
            <Button onClick={() => setShowUploadDocumentHolderModal(true)}>
              Aggiorna documento titolare
            </Button>
          </div>
        </ButtonsWrapper>
      </Wrapper>

      {showUploadDocumentHolderModal && (
        <Modal
          onCloseRequest={() => setShowUploadDocumentHolderModal(false)}
          title='Aggiornamento Documento di Identità'
        >
          <InputHolderDocumentInnerForm
            onSuccess={() => {
              setShowUploadDocumentHolderModal(false)
            }}
          ></InputHolderDocumentInnerForm>
        </Modal>
      )}

      <UpdateUserEmailModal
        isVisible={showUpdateUserEmailModal}
        onCloseRequest={() => setShowUpdateUserEmailModal(false)}
      />
    </>
  )
}

const Wrapper = styled.div`
  text-align: center;
`

const BodyWrapper = styled.div`
  margin-bottom: 3rem;
`
const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1.5rem;
`
